<ng-container *ngFor="let unit of units">
  <div class="tech-tab-add-unit" *ngIf="!unit.active && unit.canAdd">
    <button mat-icon-button type="button" [disabled]="isReadOnly()" (click)="onAdd(unit)">
      <mat-icon>add</mat-icon>
    </button>
  </div>
  <div class="tech-tab-unit" *ngIf="unit.active">
    <h4>
      {{unit.label}}
      <button *ngIf="unit.canDelete" mat-icon-button type="button" [disabled]="isReadOnly()" (click)="onDelete(unit)">
        <mat-icon>delete</mat-icon>
      </button>
    </h4>
    <h3>Types</h3>
    <digires-text-input [readOnlyState]="readOnlyState"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="gridFieldsTypeLabel"
                        placeholder="Grid Fields - Type Label"
                        tooltip="The label that is used to identify this column of Grid Connection data fields"
    ></digires-text-input>

    <h3>Grid Operator</h3>
    <digires-text-input [readOnlyState]="readOnlyState"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="networkOperator"
                        placeholder="Grid Network Operator"
                        tooltip="The name of the Grid Network Operator of the grid network that the project will connect to"
    ></digires-text-input>

    <digires-text-input [readOnlyState]="readOnlyState"
                        class="full-width"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        [textarea]="true"
                        formCtrlName="gridOperatorPowerPlantId"
                        placeholder="Grid Operator Power Plant ID"
                        tooltip="The Grid Operator's ID reference for the Grid Connection to the power plant/asset"
    ></digires-text-input>

    <digires-text-input [readOnlyState]="readOnlyState"
                        class="full-width"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        [textarea]="true"
                        formCtrlName="networkOperatorContact"
                        placeholder="Grid Connection Network Operator Contact"
                        tooltip="A description and other relevant information in relation to the contacts for the project within the Grid Connection Network Operator.  Note: Do not include any personal details such as a person' name, e-mail address or mobile phone number, instead use departmental names and contact details (i.e. switchboard, department e-mail etc. as appropriate.)"
    ></digires-text-input>

    <digires-text-input [readOnlyState]="readOnlyState"
                        class="full-width"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        [textarea]="true"
                        formCtrlName="nameOfTSO"
                        placeholder="Name of TSO"
                        tooltip="The name of the Transmission System Operator
                        (may be the same as Grid Network Operator if project is transmission connected)"
    ></digires-text-input>

    <digires-text-input [readOnlyState]="readOnlyState"
                        class="full-width"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        [textarea]="true"
                        formCtrlName="nameOfDirectMarketer"
                        placeholder="Name of Direct Marketer"
                        tooltip="The name of the Direct Marketer company that is marketing the electricity from the project"
    ></digires-text-input>

    <h3>Grid Connection</h3>
    <digires-list-input [readOnlyState]="readOnlyState"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        [items]="allConnectionTypes"
                        [itemToLabel]="connectionTypeToLabel"
                        formCtrlName="connectionType"
                        placeholder="Grid Connection Type"
                        tooltip="The type of Grid Connection - Distribution (i.e. connected to the local grid network) or Transmission (i.e. connected to the strategic grid network.)"
    ></digires-list-input>

    <digires-num-input [readOnlyState]="readOnlyState"
                       [formGroup]="formGroup"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       formCtrlName="connectionAgreementCapacity"
                       placeholder="Grid Connection Agreement Capacity (MW)"
                       tooltip="The capacity of the generating station (i.e. wind farm, solar farm, storage plant) that has been specified in the application/agreement for the connection to the grid network.  Installed capacity expressed in megawatts (MW) (number)"
                       error="Please enter a positive Number."
    ></digires-num-input>

    <digires-num-input [readOnlyState]="readOnlyState"
                       [formGroup]="formGroup"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       formCtrlName="connectionVoltage"
                       placeholder="Grid Connection Voltage (kV)"
                       tooltip="The voltage of that part of the grid network that is being utilised for the project's grid connection.  The connection voltage is expressed in kV (kilovolts)."
    ></digires-num-input>

    <digires-num-input [readOnlyState]="readOnlyState"
                       [formGroup]="formGroup"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       decimalDigits="6"
                       formCtrlName="connectionPointLatitude"
                       placeholder="Coordinates of the Grid Connection Point - Latitude"
                       tooltip="The Latitude & Longitude Coordinates for the Grid Connection Point using the Decimal Degree system WGS84 (to 6 decimal places)"
    ></digires-num-input>

    <digires-num-input [readOnlyState]="readOnlyState"
                       [formGroup]="formGroup"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       decimalDigits="6"
                       formCtrlName="connectionPointLongitude"
                       placeholder="Coordinates of the Grid Connection Point - Longitude"
                       tooltip="The Latitude & Longitude Coordinates for the Grid Connection Point using the Decimal Degree system WGS84 (to 6 decimal places)"
    ></digires-num-input>

    <digires-text-input [readOnlyState]="readOnlyState"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        [textarea]="true"
                        formCtrlName="connectionPoint"
                        placeholder="Grid Connection Point(s)"
                        tooltip="Details of the location/name/description of the Connection Point on the grid network for the project. In Germany this can also be the Pylon Number."
    ></digires-text-input>

    <digires-list-input [readOnlyState]="readOnlyState"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        [items]="allConnectionReadinessOptions"
                        [itemToLabel]="connectionReadinessOptionToLabel"
                        formCtrlName="connectionReadinessExternal"
                        placeholder="Connection Readiness of External Substation"
                        tooltip="Identification of the readiness of the External Substation, select from the drop down list: - It exists, no upgrades are required;- To be upgraded;- To be built by Grid Operator;- To be built by RWE."
    ></digires-list-input>

    <digires-text-input [readOnlyState]="readOnlyState"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="mainTransformerManufacturer"
                        placeholder="Manufacturer of Main Transformer in External Substation"
                        tooltip="The name of the manufacturer of the Main Transformer in the external substation."
    ></digires-text-input>

    <digires-text-input [readOnlyState]="readOnlyState"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="transformerMvaRatingExternal"
                        placeholder="Transformer MVA Rating of Main Transformer in External Substation"
                        tooltip="The MVA (Megavolt-Amperes) rating of the Main Transformer in the external substation
                        identifying the amount of apparent power that the transformer can handle. The rating can be
                        expressed with and without any additional cooling (e.g. 50/63MVA ONAN/ONAF)."
    ></digires-text-input>

    <digires-list-input [readOnlyState]="readOnlyState"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        [items]="allTypesOfConnectionMethods"
                        [itemToLabel]="connectionMethodTypeToLabel"
                        formCtrlName="typeOfConnectionMethod"
                        placeholder="Type of Connection Method"
                        tooltip="The Method used for making the Grid Connection based on its Type: 'Substation' or
                        'Transfer Station' or 'Other' (i.e. for other types that are not covered by Substation or
                        Transfer Station.)"
    ></digires-list-input>

    <digires-text-input [readOnlyState]="readOnlyState"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        [textarea]="true"
                        formCtrlName="typeOfConnectionNotes"
                        placeholder="Type of Connection - Notes"
                        tooltip="Notes on the Type of Connection"
    ></digires-text-input>

    <digires-num-input [readOnlyState]="readOnlyState"
                       [formGroup]="formGroup"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       formCtrlName="connectionDistance"
                       placeholder="Grid Connection Distance (km)"
                       tooltip="The distance from the project (1st turbine, 1st PV converter or project’s substation) and the point of connection into the grid network. The connection distance as expressed in km (kilometres)"
    ></digires-num-input>

    <digires-list-input [readOnlyState]="readOnlyState"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        [items]="allConnectionMethods"
                        [itemToLabel]="connectionMethodToLabel"
                        formCtrlName="connectionMethod"
                        placeholder="Grid Connection Method"
                        tooltip="The method of Grid Connection - Overhead Line (i.e. connected overground using poles,
                        pylons etc. to elevate the line above ground); Underground Cable (i.e. connected using cable
                        that is buried underground) or a Mixture of Over and Under (i.e. where stretches of both
                        overhead line and underground cable are involved.)"
    ></digires-list-input>

    <h3>On Site Satellite Substations</h3>

    <digires-num-input [readOnlyState]="readOnlyState"
                       [formGroup]="formGroup"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       decimalDigits="0"
                       formCtrlName="numberOfSubstations"
                       placeholder="Number of On Site Satellite Substations"
                       tooltip="Number of on site substation buildings required for the project at the site, these are
                       often referred to as satellite substations."
                       error="Please enter a whole Number. Any decimals going to be cut of"
    ></digires-num-input>

    <digires-text-input [readOnlyState]="readOnlyState"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="satelliteSubstationManufacturer"
                        placeholder="Manufacturer of the On Site Satellite Substations"
                        tooltip="The name of the manufacturer of the on site prefabricated substation buildings required
                        for the project at the site, these are often referred to as satellite substations."
    ></digires-text-input>

    <h3>Main On Site Substation</h3>

    <digires-text-input [readOnlyState]="readOnlyState"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="externalSubstationOperator"
                        placeholder="Operator of Main On Site Substation"
                        tooltip="The name of the Operator of the Main on Site Substation that is part of the project."
    ></digires-text-input>

    <digires-fake-input placeholder="Number of Transformers in the Main On Site Substation"
                        tooltip="Count of the number of Transformers in the Main On Site Substation."
                        [readOnlyReasonEnum]="readOnlyReasonCalculated"
                        [value]="unit.fg.value['transformerEntries'].length"
    ></digires-fake-input>

    <digires-transformer-entry-list [disabled]="isReadOnly()" [formGroup]="unit.fg.get('transformerEntries')"></digires-transformer-entry-list>

    <digires-text-input [readOnlyState]="readOnlyState"
                      class="full-width"
                      [formGroup]="formGroup"
                      [initialData]="initialData"
                      [formCtrlPath]="[unit.id]"
                      [textarea]="true"
                      formCtrlName="substationNotes"
                      placeholder="Project Substation Notes"
                      tooltip="A description and other relevant information in relation to the substation for the project."
    ></digires-text-input>

    <digires-text-input [readOnlyState]="readOnlyState"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        [textarea]="true"
                        formCtrlName="gridOperatorSubstationEarthingMethod"
                        placeholder="Grid Operator Main On Site Substation Earthing Method"
                        tooltip="The Earthing system method that is being used to provide earthing for the project's Main On Site Substation."
    ></digires-text-input>

    <h3>Metering</h3>

    <digires-fake-input placeholder="Number of Meters (HV, MV)"
                        tooltip="A count of the number of Meters included in this grid connection."
                        [readOnlyReasonEnum]="readOnlyReasonCalculated"
                        [value]="unit.fg.value['meterEntries'].length"
    ></digires-fake-input>

    <digires-meter-entry-list [disabled]="isReadOnly()" [formGroup]="unit.fg.get('meterEntries')"></digires-meter-entry-list>

    <digires-text-input [readOnlyState]="readOnlyState"
                        class="full-width"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        [textarea]="true"
                        formCtrlName="meteringNotes"
                        placeholder="Project Metering Notes"
                        tooltip="A description and other relevant information in relation to the metering of the grid connection for the project."
    ></digires-text-input>

    <h3>On Site Collection Network</h3>
    <digires-num-input [readOnlyState]="readOnlyState"
                       [formGroup]="formGroup"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       decimalDigits="1"
                       formCtrlName="internalVoltage"
                       placeholder="Internal (Array) Voltage (kV)"
                       error="Please enter a non-negative number"
                       tooltip="The Voltage (kV) of the arrays of cables that connect up the component parts of the project within the site."
    ></digires-num-input>

    <digires-num-input [readOnlyState]="readOnlyState"
                       [formGroup]="formGroup"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       decimalDigits="0"
                       formCtrlName="numberOfTransformers"
                       placeholder="Number of MV Transformers"
                       error="Please enter a non-negative number"
                       tooltip="The number of Medium Voltage transformers that the project includes within the site."
    ></digires-num-input>

    <digires-text-input [readOnlyState]="readOnlyState"
                       [formGroup]="formGroup"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       formCtrlName="manufacturerOfTransformers"
                       placeholder="Manufacturer of MV Transformers"
                       tooltip="The name of the manufacturer of the Medium Voltage transformers that the project includes within the site."
    ></digires-text-input>

    <digires-text-input [readOnlyState]="readOnlyState"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="mvaRatingMvTransformers"
                        placeholder="MVA Rating of MV Transformers"
                        tooltip="The MVA (Megavolt-Amperes) rating of MV (Medium Voltage) Transformers identifying the amount of apparent power that the transformer can handle."
    ></digires-text-input>

    <digires-num-input [readOnlyState]="readOnlyState"
                       [formGroup]="formGroup"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       decimalDigits="0"
                       formCtrlName="numberOfFeederCircuits"
                       placeholder="Number of Feeder Circuits"
                       error="Please enter a non-negative number"
                       tooltip="The number of Feeder Circuit array/string(s) that the project includes within the site."
    ></digires-num-input>

    <digires-text-input [readOnlyState]="readOnlyState"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="feederCircuitIds"
                        placeholder="Feeder Circuit ID(s)"
                        tooltip="The Identification (ID) number/text for the Feeder Circuit array/string(s) that the project includes within the site."
    ></digires-text-input>

    <digires-text-input [readOnlyState]="readOnlyState"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="namesOfSiteOperators"
                        placeholder="Name(s) of the Site Operator(s)"
                        tooltip="The name(s) of the Operator(s) of the site - default value is RWE."
    ></digires-text-input>

    <h3>General</h3>
    <digires-text-input [readOnlyState]="readOnlyState"
                        class="full-width"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        [textarea]="true"
                        formCtrlName="comment"
                        placeholder="Further Information"
                        tooltip="Any other relevant information and comments about the grid connection that may be helpful to others in the future"
    ></digires-text-input>

    <h3>Important Dates</h3>
    <digires-date-input [readOnlyState]="readOnlyState"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="screeningDate"
                        placeholder="Grid Screening Completed"
                        tooltip="The date that the Grid Screening activity (usually during Stage 1. - Origination) was completed"
    ></digires-date-input>

    <digires-date-input [readOnlyState]="readOnlyState"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="assessmentDate"
                        placeholder="Grid Assessment Completed"
                        tooltip="The date that the detailed technical Grid Assessment was completed"
    ></digires-date-input>

    <digires-date-input [readOnlyState]="readOnlyState"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="connectionOfferSubmittedDate"
                        placeholder="Application for Grid Connection Offer Submitted"
                        tooltip="The date that the application for a grid connection offer was submitted to the grid network operator.  Where multiple submissions are made use the date for the submission that is being relied upon for the project's grid connection."
    ></digires-date-input>

    <digires-date-input [readOnlyState]="readOnlyState"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="connectionOfferReceivedDate"
                        placeholder="Grid Connection Offer Received"
                        tooltip="The date that the offer is received the grid network operator in response to the application for a grid connection offer.  Where multiple offers are received use the date for the offer that is being relied upon for the project's grid connection."
    ></digires-date-input>

    <digires-date-input [readOnlyState]="readOnlyState"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="connectionOfferSignOffDate"
                        placeholder="Grid Connection Offer Sign Off"
                        tooltip="Insert the date of the internal sign off of the Grid Recommendation Paper recommending that the grid offer be accepted"
    ></digires-date-input>

    <digires-date-input [readOnlyState]="readOnlyState"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="connectionOfferAcceptedDate"
                        placeholder="Grid Connection Offer Accepted"
                        tooltip="Insert the date of the formal acceptance of the grid offer, creating a legally binding commitment to a grid connection."
    ></digires-date-input>

    <digires-date-input [readOnlyState]="readOnlyState"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="energisationDateAgreed"
                        placeholder="Grid Energisation Date: in Agreement/Planned"
                        tooltip="The date that is identified in the Grid Connection Agreement for the energisation of the project's grid connection.  In Germany, as there is no Contractual Agreement then insert the Planned Energization date."
    ></digires-date-input>

    <digires-date-input [readOnlyState]="readOnlyState"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="energisationDateActual"
                        placeholder="Grid Energisation Date: Expected/Actual"
                        tooltip="Prior to energisation of the project’s grid connection taking place this is the date
                        when energisation is expected to be achieved, and after energisation is achieved it is the
                        actual date when the energisation took place."
    ></digires-date-input>

    <digires-text-input [readOnly]="true"
                        readOnlyReason="Calculated as the difference between 'Grid Energisation Date: in Agreement' and 'Grid Energisation Date: Actual'"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="energisationDateDifference"
                        placeholder="Grid Energisation Date: Difference"
                        tooltip="The difference between the energisation date as contained in the Grid Connection Agreement and the actual date when the project's grid connection was energised."
    ></digires-text-input>
  </div>
</ng-container>
